
/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-650913b6&scoped=true!./Quote.css")

var Component = require("/quotes-front/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./Quote.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-650913b6!./../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./Quote.pug"),
  /* scopeId */
  "data-v-650913b6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Quote/Quote.vue
// module id = 253
// module chunks = 2